module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Bold.776eefe.ttf";